<template>
	<div class="px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-900 flex items-center gap-2 cursor-pointer whitespace-nowrap">
		<slot/>
	</div>
</template>
<script setup lang="ts"></script>
